"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotGavel = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotGavel = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 41"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#gavel_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M5.213 19.076C6.95 13.988 13.128 9.289 18.586 7.48c5.482-1.817 11.979-.36 16.282 3.89 4.304 4.25 6.403 10.61 5.107 15.97-1.26 5.373-5.756 8.607-9.715 10.582-3.983 1.984-7.428 1.992-11.538.997-4.123-.96-8.3-2.541-10.447-6.26-2.147-3.72-4.825-8.487-3.062-13.584Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeWidth: strokeWidth,
    d: "m14.595 28.57-8.64-10.953a2.122 2.122 0 0 1 3.33-2.628l8.642 10.954a2.122 2.122 0 1 1-3.332 2.628ZM29.643 16.595l-8.64-10.953a2.121 2.121 0 1 1 3.33-2.628l8.642 10.953a2.121 2.121 0 1 1-3.332 2.628Z"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "gavel_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m8.865 13.984 11.201-8.836 9.955 12.618-11.201 8.836-9.955-12.618Z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    d: "m10.228 15.711 11.2-8.836-2.725-3.454-11.2 8.836 2.725 3.454Zm18.43.328-11.2 8.836 2.725 3.455 11.2-8.837-2.725-3.454Z",
    mask: "url(#gavel_svg__b)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeWidth: strokeWidth,
    d: "m21.592 22.358 11.486 16.134a2.667 2.667 0 0 0 3.824.547l.7-.551a2.667 2.667 0 0 0 .36-3.844L24.96 19.701M18.523 39.768l-17.38.039-.015-1.133a3.636 3.636 0 0 1 3.59-3.683l10.125-.131a3.636 3.636 0 0 1 3.683 3.646l-.003 1.262Z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "gavel_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 .939h40v40H0z"
  }))));
};
exports.SpotGavel = SpotGavel;
SpotGavel.displayName = "SpotGavel";